import { Link as ReactRouterLink } from "react-router";

import { initializeButtonLinkComponent } from "@bokio/design-system-base/components/Button/Button";

import type { ButtonLinkComponentType } from "@bokio/design-system-base/components/Button/Button";

const Link: ButtonLinkComponentType = ({ ref, ...props }) => {
	return (
		<ReactRouterLink
			{...props}
			// eslint-disable-next-line @typescript-eslint/no-explicit-any -- SS 2026-03-24 The type is actually correct but the import path difference is causing TS to see 2 different types with the same name. Unsure how to fix cleanly here for now.
			ref={ref as any}
		/>
	);
};

initializeButtonLinkComponent(Link);

export { Button } from "@bokio/design-system-base/components/Button/Button";
export type { ButtonProps, ButtonPropsUnion } from "@bokio/design-system-base/components/Button/Button";
